import {HttpErrorResponse} from '@angular/common/http';
import {ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {AssociationsService} from '@shared/services/associations.service';
import {SharedService} from '@shared/shared.service';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject, catchError, EMPTY, Subject} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {OrganizationTariffModel} from "@services/back-office/model/organizationTariffModel";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BillingCounterpartyModel} from '@services/back-office';

@Component({
    selector: 'app-counterparty-tariff-dialog',
    templateUrl: './counterparty-tariff-dialog.component.html',
    styleUrls: ['./counterparty-tariff-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CounterpartyTariffDialogComponent implements OnInit, OnDestroy {
    /** Subject to destroy Subscriptions */
    private destroyed$ = new Subject<void>();
    /** Loading */
    loading$ = new BehaviorSubject(false);
    /** Form */
    tariffForm: UntypedFormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            counterparty: BillingCounterpartyModel
        },
        public dialogRef: MatDialogRef<CounterpartyTariffDialogComponent>,
        private associationsService: AssociationsService,
        private formBuilder: UntypedFormBuilder,
        private translateService: TranslateService,
        private toastrService: ToastrService,
    ) {
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.tariffForm = this.formBuilder.group({
            startDate: [{value: new Date(), disabled: true}, [Validators.required]],
            tariff: [this.data.counterparty.tariff, [Validators.required]],
        });
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
        this.loading$.complete();
    }

    submitForm() {
        const formData = this.tariffForm.getRawValue();
        this.loading$.next(true);

        this.associationsService.addTariff(this.data.counterparty.id, formData.tariff).pipe(
            take(1),
            map((response: OrganizationTariffModel) => {
                this.loading$.next(false);
                this.closeDialog(true, response);
            }),
            catchError((error: HttpErrorResponse) => {
                SharedService.showErrorWithTitle(
                    this.translateService,
                    this.toastrService,
                    `responseErrors.${error.error.message}`
                );
                this.loading$.next(false);
                return EMPTY;
            })
        ).subscribe();

    }

    /** Close dialog */
    closeDialog(result: boolean, data?: any) {
        this.dialogRef.close({result, data});
    }
}
